import _ from 'lodash';
import BaseModel, {defineTranslatableProperties} from "@/core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class BacsSearch extends BaseModel {
  batch_id = null;
  settlement_no = null;

  rules = {};

  attributeLabels = {
    settlement_no: i18n.t("Settlement Number"),
    batch_id: i18n.t("BACS ID"),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    delete data.customer;

    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(BacsSearch);
